module.exports = __webpack_public_path__ + "img/iPhone 16.f676fd51.jpg";